import React from 'react';

const PlusIcon: React.FC = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.625 0C3.4171 0 3.21333 0.0203898 3.0158 0.0594677L3.25839 1.2857C3.37646 1.26235 3.49898 1.25 3.625 1.25H4.19792V0H3.625Z"
            fill="white"
        />
        <path d="M6.48958 0H5.34375V1.25H6.48958V0Z" fill="white" />
        <path d="M8.78125 0H7.63542V1.25H8.78125V0Z" fill="white" />
        <path d="M11.0729 0H9.92708V1.25H11.0729V0Z" fill="white" />
        <path d="M13.3646 0H12.2188V1.25H13.3646V0Z" fill="white" />
        <path d="M15.6562 0H14.5104V1.25H15.6562V0Z" fill="white" />
        <path
            d="M17.375 0H16.8021V1.25H17.375C17.501 1.25 17.6235 1.26235 17.7416 1.2857L17.9842 0.0594677C17.7867 0.0203898 17.5829 0 17.375 0Z"
            fill="white"
        />
        <path
            d="M19.9733 1.38826C19.7453 1.04774 19.4523 0.754701 19.1117 0.526731L18.4163 1.56544C18.6211 1.70251 18.7975 1.87892 18.9346 2.08366L19.9733 1.38826Z"
            fill="white"
        />
        <path
            d="M1.88826 0.526731C1.54774 0.754701 1.2547 1.04775 1.02673 1.38826L2.06544 2.08366C2.20251 1.87892 2.37892 1.70251 2.58366 1.56544L1.88826 0.526731Z"
            fill="white"
        />
        <path
            d="M20.5 3.125C20.5 2.9171 20.4796 2.71333 20.4405 2.5158L19.2143 2.75839C19.2377 2.87646 19.25 2.99898 19.25 3.125V3.69792H20.5V3.125Z"
            fill="white"
        />
        <path
            d="M0.559468 2.5158C0.52039 2.71334 0.5 2.9171 0.5 3.125V3.69792H1.75V3.125C1.75 2.99898 1.76235 2.87646 1.7857 2.75839L0.559468 2.5158Z"
            fill="white"
        />
        <path d="M0.5 4.84375V5.98958H1.75V4.84375H0.5Z" fill="white" />
        <path d="M20.5 5.98958V4.84375H19.25V5.98958H20.5Z" fill="white" />
        <path d="M0.5 7.13542V8.28125H1.75V7.13542H0.5Z" fill="white" />
        <path d="M20.5 8.28125V7.13542H19.25V8.28125H20.5Z" fill="white" />
        <path d="M0.5 9.42708V10.5729H1.75V9.42708H0.5Z" fill="white" />
        <path d="M19.25 10.5729H20.5V9.42708H19.25V10.5729Z" fill="white" />
        <path d="M0.5 11.7187V12.8646H1.75V11.7187H0.5Z" fill="white" />
        <path d="M20.5 12.8646V11.7188H19.25V12.8646H20.5Z" fill="white" />
        <path d="M0.5 14.0104V15.1562H1.75V14.0104H0.5Z" fill="white" />
        <path d="M20.5 15.1562V14.0104H19.25V15.1562H20.5Z" fill="white" />
        <path
            d="M0.5 16.3021V16.875C0.5 17.0829 0.52039 17.2867 0.559468 17.4842L1.7857 17.2416C1.76235 17.1235 1.75 17.001 1.75 16.875V16.3021H0.5Z"
            fill="white"
        />
        <path
            d="M20.5 16.875V16.3021H19.25V16.875C19.25 17.001 19.2377 17.1235 19.2143 17.2416L20.4405 17.4842C20.4796 17.2867 20.5 17.0829 20.5 16.875Z"
            fill="white"
        />
        <path
            d="M1.02673 18.6117C1.2547 18.9523 1.54775 19.2453 1.88826 19.4733L2.58366 18.4346C2.37892 18.2975 2.20251 18.1211 2.06544 17.9163L1.02673 18.6117Z"
            fill="white"
        />
        <path
            d="M19.1117 19.4733C19.4523 19.2453 19.7453 18.9523 19.9733 18.6117L18.9346 17.9163C18.7975 18.1211 18.6211 18.2975 18.4163 18.4346L19.1117 19.4733Z"
            fill="white"
        />
        <path
            d="M3.0158 19.9405C3.21334 19.9796 3.4171 20 3.625 20H4.19792V18.75H3.625C3.49898 18.75 3.37646 18.7377 3.25839 18.7143L3.0158 19.9405Z"
            fill="white"
        />
        <path
            d="M17.375 20C17.5829 20 17.7867 19.9796 17.9842 19.9405L17.7416 18.7143C17.6235 18.7377 17.501 18.75 17.375 18.75H16.8021V20H17.375Z"
            fill="white"
        />
        <path d="M5.34375 20H6.48958V18.75H5.34375V20Z" fill="white" />
        <path d="M7.63542 20H8.78125V18.75H7.63542V20Z" fill="white" />
        <path d="M9.92708 18.75V20H11.0729V18.75H9.92708Z" fill="white" />
        <path d="M12.2187 20H13.3646V18.75H12.2187V20Z" fill="white" />
        <path d="M14.5104 20H15.6562V18.75H14.5104V20Z" fill="white" />
        <path
            d="M11.125 5.625C11.125 5.27982 10.8452 5 10.5 5C10.1548 5 9.875 5.27982 9.875 5.625V9.375H6.125C5.77982 9.375 5.5 9.65482 5.5 10C5.5 10.3452 5.77982 10.625 6.125 10.625H9.875V14.375C9.875 14.7202 10.1548 15 10.5 15C10.8452 15 11.125 14.7202 11.125 14.375V10.625H14.875C15.2202 10.625 15.5 10.3452 15.5 10C15.5 9.65482 15.2202 9.375 14.875 9.375H11.125V5.625Z"
            fill="white"
        />
    </svg>
);

export default PlusIcon;
